import React, { Component } from "react";
import { connect } from "react-redux";
import { Menu, Switch, Radio, Modal, Tooltip, Icon } from "antd";
import { Link } from "react-router-dom";
import { ReactComponent as DashboardIcon } from '../../assets/images/icons/dashboard-icon.svg';
import { ReactComponent as VerifyIcon } from '../../assets/images/icons/verify-icon.svg';
import { ReactComponent as RadiologistIcon } from '../../assets/images/icons/radiologist-icon.svg';
import { ReactComponent as PrivateTempIcon } from '../../assets/images/icons/private-temp-icon.svg';
import { ReactComponent as PrivateDiagramIcon } from '../../assets/images/icons/private-diagram-icon.svg';
import { ReactComponent as ContactIcon } from '../../assets/images/icons/contact-icon.svg';
import { ReactComponent as TypingIcon } from '../../assets/images/icons/typing.svg';
import { ReactComponent as ParkedIcon } from '../../assets/images/icons/parked.svg';
import { ReactComponent as SubmittedIcon } from '../../assets/images/icons/submitted.svg';
import { AiOutlineLogout } from "react-icons/ai";
import { FiSun, FiMoon } from "react-icons/fi";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";

import Auxiliary from "util/Auxiliary";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  THEME_TYPE_DARK,
  THEME_TYPE_SEMI_DARK

} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { fetchDashboard } from "../../appRedux/actions/dashboardActions";
import { bindActionCreators } from "redux";
import { onNavStyleChange, setThemeType, userSignOut } from "../../appRedux/actions";
import CreateTicketModal from "../../components/common/CreateTicketModal";
import Claire from "../../components/common/Claire";
import WhatsNewModal from "../../components/common/WhatsNewModal";
import { updateUserConfigurations } from "../../appRedux/actions/Auth";
import { CASE_LIBRARY_ENABLED_HOSTS } from "../../constants/constants";
import { CONFIRM_TEXT, UNSAVED_CHANGES_CONFIRM_TEXT } from "../../constants/messages";
import { unlockVisitAPI } from "../../services/locked-visits-service";


const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const { confirm } = Modal

class SidebarContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ticketModal: false,
      whatsNewModal: false,
      whatsNewMandatory: false,
      whatsNewAutoShown: false,
    }
  }

  componentDidMount() {
    this.maybeAutoShowWhatsNew();
  }

  componentDidUpdate() {
    this.maybeAutoShowWhatsNew();
  }

  maybeAutoShowWhatsNew = () => {
    const { configurations } = this.props;
    if (
      !this.state.whatsNewAutoShown &&
      !this.state.whatsNewModal &&
      configurations &&
      configurations.initial_whats_new_view === false
    ) {
      this.setState({ whatsNewModal: true, whatsNewMandatory: true, whatsNewAutoShown: true });
    }
  }

  handleWhatsNewComplete = () => {
    if (this.props.updateUserConfigurations) {
      this.props.updateUserConfigurations([
        { name: "initial_whats_new_view", value: true }
      ], () => {});
    }
  }
  getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR || navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };


  onThemeTypeChange = (e) => {
    this.props.setThemeType(e.target.value);
  };

  handleTicketModal = () => {
    this.setState({ ticketModal: true })
  }

  handleCancelModal = () => {
    this.setState({
      ticketModal: false,
    })
  }

  handleWhatsNewModal = () => {
    this.setState({ whatsNewModal: true, whatsNewMandatory: false })
  }

  handleCancelWhatsNewModal = () => {
    this.setState({ whatsNewModal: false, whatsNewMandatory: false })
  }

  handleLogout = () => {
    const { unsavedChanges, selectedVisit } = this.props;
    const { isVisitLocked, reportId } = selectedVisit;

    let that = this;

    if (unsavedChanges) {
      confirm({
        title: UNSAVED_CHANGES_CONFIRM_TEXT,
        async onOk() {
          if (reportId !== null) {
            let result = await unlockVisitAPI(reportId);
            if (result.success) {
              await that.props.userSignOut()
            }
          }
          that.props.userSignOut()
        },
        onCancel() {
          // Cancel
        }
      })
    } else if (isVisitLocked) {
      confirm({
        title: CONFIRM_TEXT,
        async onOk() {

          if (reportId !== null) {
            let result = await unlockVisitAPI(reportId);
            if (result.success) {
              await that.props.userSignOut()
            } else if (result.error == "Visit is not in locked state!") {
              await that.props.userSignOut()
            }
          } else {
            await that.props.userSignOut()
          }
        },
        onCancel() {
          // Cancel
        }
      })
    } else {
      this.props.userSignOut();
    }
  }

  render() {
    const { themeType, navStyle, pathname, authUser, dashboard } = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];
    const showCaseLibrary = CASE_LIBRARY_ENABLED_HOSTS.includes(window.location.hostname);

    return (
      <Auxiliary>
        <SidebarLogo />
        <div id="custom-sidebar-content" className="gx-sidebar-content">
          <div className={`gx-sidebar-notifications ${this.getNoHeaderClass(navStyle)}`}>
            <UserProfile />
            {/* <AppsNavigation /> */}
          </div>
          <CustomScrollbars id="custom-sidebar" className="gx-layout-sider-scrollbar">
            {
              authUser && authUser.role === "ROLE_ADMIN" ?
                <Menu
                  defaultOpenKeys={[defaultOpenKeys]}
                  selectedKeys={[selectedKeys]}
                  theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                  mode="inline"
                  id="custom-sidebar-menu">
                  <Menu.Item key="admin/dashboard">
                    <Link to="/admin/dashboard">
                      <span className="nav-item-icon"><DashboardIcon /></span>
                      <span className="nav-item-label"><IntlMessages id="sidebar.dashboard" /></span>
                    </Link>
                  </Menu.Item>
                  <SubMenu key="master" className={this.getNavStyleSubMenuClass(navStyle)}
                    title={<span><span className="nav-item-icon"><i className="icon icon-dasbhoard" /></span><span className="nav-item-label"><IntlMessages id="sidebar.master" /></span></span>}>
                    <Menu.Item key="admin/master/users">
                      <Link to="/admin/master/users">
                        <span className="nav-item-icon"><i className="icon icon-crypto" /></span>
                        <span className="nav-item-label"><IntlMessages id="sidebar.master.users" /></span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="admin/master/sites">
                      <Link to="/admin/master/sites">
                        <span className="nav-item-icon"><i className="icon icon-crm" /></span>
                        <span className="nav-item-label"><IntlMessages id="sidebar.master.sites" /></span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="admin/master/groups">
                      <Link to="/admin/master/groups">
                        <span className="nav-item-icon"><i className="icon icon-timeline-left-align" /></span>
                        <span className="nav-item-label"><IntlMessages id="sidebar.master.groups" /></span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                  {/* <Menu.Item key="admin/reports">
                    <Link to="/admin/reports"><i className="icon icon-copy" />
                      <IntlMessages id="sidebar.visitsReport" /></Link>
                  </Menu.Item> */}
                  <Menu.Item key="search-visit">
                    <Link to="/admin/search-visit">
                      <span className="nav-item-icon"><i className="icon icon-search" /></span>
                      <span className="nav-item-label"><IntlMessages id="sidebar.searchVisit" /></span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="admin/hl7-received-messages">
                    <Link to="/admin/hl7-received-messages">
                      <span className="nav-item-icon"><RadiologistIcon /></span>
                      <span className="nav-item-label"><IntlMessages id="sidebar.hl7-received-messages" /></span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="admin/hl7-sent-messages">
                    <Link to="/admin/hl7-sent-messages">
                      <span className="nav-item-icon"><RadiologistIcon /></span>
                      <span className="nav-item-label"><IntlMessages id="sidebar.hl7sentmessages" /></span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="admin/hl7-queue-messages">
                    <Link to="/admin/hl7-queue-messages">
                      <span className="nav-item-icon"><RadiologistIcon /></span>
                      <span className="nav-item-label"><IntlMessages id="sidebar.hl7-queue-messages" /></span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="logged-in-users">
                    <Link to="/admin/logged-in-users">
                      <span className="nav-item-icon"><i className="icon icon-timeline-left-align" /></span>
                      <span className="nav-item-label"><IntlMessages id="sidebar.loggedinusers" /></span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="locked-visits">
                    <Link to="/admin/locked-visits">
                      <span className="nav-item-icon"><i className="icon icon-timeline-left-align" /></span>
                      <span className="nav-item-label"><IntlMessages id="sidebar.lockedvisits" /></span>
                    </Link>
                  </Menu.Item>
                </Menu>
                : authUser && authUser.role === "ROLE_GUILDLIBRARIAN" ?
                  <Menu
                    defaultOpenKeys={[defaultOpenKeys]}
                    selectedKeys={[selectedKeys]}
                    theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                    mode="inline"
                    id="custom-sidebar-menu">
                    <Menu.Item key="guildlibrarian/dashboard">
                      <Link to="/guildlibrarian/dashboard">
                        <span className="nav-item-icon"><DashboardIcon /></span>
                        <span className="nav-item-label"><IntlMessages id="sidebar.dashboard" /></span>
                      </Link>
                    </Menu.Item>
                    <li className="tool-tip">Templates</li>
                    <Menu.Item key="guildlibrarian/public-macros">
                      <Link to="/guildlibrarian/public-macros">
                        <span className="nav-item-icon"><PrivateTempIcon /></span>
                        <span className="nav-item-label"><IntlMessages id="sidebar.publicMacros" /></span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="guildlibrarian/public-diagram-templates">
                      <Link to="/guildlibrarian/public-diagram-templates">
                        <span className="nav-item-icon"><PrivateDiagramIcon /></span>
                        <span className="nav-item-label"><IntlMessages id="sidebar.public-diagrams" /></span>
                      </Link>
                    </Menu.Item>
                  </Menu>
                  : authUser && authUser.role === "ROLE_GROUPADMIN" ?
                    <Menu
                      defaultOpenKeys={[defaultOpenKeys]}
                      selectedKeys={[selectedKeys]}
                      theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                      mode="inline"
                      id="custom-sidebar-menu">
                      <Menu.Item key="groupadmin/dashboard">
                        <Link to="/groupadmin/dashboard">
                          <span className="nav-item-icon"><DashboardIcon /></span>
                          <span className="nav-item-label"><IntlMessages id="sidebar.dashboard" /></span>
                        </Link>
                      </Menu.Item>
                      <li className="tool-tip">Workflow Tools</li>
                      <Menu.Item key="groupadmin/submitted-for-verification" className="verify">
                        <Link to="/groupadmin/submitted-for-verification">
                          <span className="nav-item-icon">
                            <VerifyIcon />
                            <span className="nav-item-badge">{this.props.dashboard && this.props.dashboard.visits && this.props.dashboard.visits.submittedForVerification ? this.props.dashboard.visits.submittedForVerification : 0}</span>
                          </span>
                          <span className="nav-item-label"><IntlMessages id="sidebar.submitted-for-verification" />{this.props.dashboard && this.props.dashboard.visits && this.props.dashboard.visits.submittedForVerification ? this.props.dashboard.visits.submittedForVerification : 0}</span>
                        </Link>
                      </Menu.Item>
                      <Menu.Item key="groupadmin/worklist-visits">
                        <Link to="/groupadmin/worklist-visits">
                          <span className="nav-item-icon"><RadiologistIcon /></span>
                          <span className="nav-item-label"><IntlMessages id="sidebar.worklist-visits" /></span>
                        </Link>
                      </Menu.Item>
                      <li className="tool-tip">Templates</li>
                      <Menu.Item key="search-visit">
                        <Link to="/groupadmin/search-visit">
                          <span className="nav-item-icon"><i className="icon icon-search" /></span>
                          <span className="nav-item-label"><IntlMessages id="sidebar.searchVisit" /></span>
                        </Link>
                      </Menu.Item>
                      <Menu.Item key="groupadmin/group-templates">
                        <Link to="/groupadmin/group-templates">
                          <span className="nav-item-icon"><PrivateTempIcon /></span>
                          <span className="nav-item-label"><IntlMessages id="sidebar.group-macros" /></span>
                        </Link>
                      </Menu.Item>
                      {showCaseLibrary && <Menu.Item key="groupadmin/library">
                        <Link to="/groupadmin/library">
                          <span className="nav-item-icon"><RadiologistIcon /></span>
                          <span className="nav-item-label"><IntlMessages id="sidebar.library" /></span>
                        </Link>
                      </Menu.Item>}
                    </Menu>
                    : authUser && authUser && authUser.role === "ROLE_MRT" ?
                      <Menu
                        defaultOpenKeys={[defaultOpenKeys]}
                        selectedKeys={[selectedKeys]}
                        theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                        mode="inline"
                        id="custom-sidebar-menu">
                        <Menu.Item key="mrt/dashboard">
                          <Link to="/mrt/dashboard">
                            <span className="nav-item-icon"><DashboardIcon /></span>
                            <span className="nav-item-label"><IntlMessages id="sidebar.dashboard" /></span>
                          </Link>
                        </Menu.Item>
                        <li className="tool-tip">Workflow Tools</li>
                        <Menu.Item key="mrt/submitted-for-verification" className="verify">
                          <Link to="/mrt/submitted-for-verification">
                            <span className="nav-item-icon">
                              <VerifyIcon />
                              <span className="nav-item-badge">{this.props.dashboard && this.props.dashboard.visits && this.props.dashboard.visits.submittedForVerification ? this.props.dashboard.visits.submittedForVerification : 0}</span>
                            </span>
                            <span className="nav-item-label">SFV - {this.props.dashboard && this.props.dashboard.visits && this.props.dashboard.visits.submittedForVerification ? this.props.dashboard.visits.submittedForVerification : 0}</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="mrt/worklist-visits">
                          <Link to="/mrt/worklist-visits">
                            <span className="nav-item-icon"><RadiologistIcon /></span>
                            <span className="nav-item-label"><IntlMessages id="sidebar.worklist-visits" /></span>
                          </Link>
                        </Menu.Item>
                        <li className="tool-tip">Templates</li>
                        <Menu.Item key="mrt/private-templates">
                          <Link to="/mrt/private-templates">
                            <span className="nav-item-icon"><PrivateTempIcon /></span>
                            <span className="nav-item-label"><IntlMessages id="sidebar.private-macros" /></span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="mrt/private-diagram">
                          <Link to="/mrt/private-diagram">
                            <span className="nav-item-icon"><PrivateDiagramIcon /></span>
                            <span className="nav-item-label"><IntlMessages id="sidebar.private-diagrams" /></span>
                          </Link>
                        </Menu.Item>
                        {showCaseLibrary && <Menu.Item key="mrt/library">
                          <Link to="/mrt/library">
                            <span className="nav-item-icon"><PrivateDiagramIcon /></span>
                            <span className="nav-item-label"><IntlMessages id="sidebar.library" /></span>
                          </Link>
                        </Menu.Item>}
                      </Menu> :
                      authUser && authUser.role === "ROLE_MIS" ?
                        <Menu
                          defaultOpenKeys={[defaultOpenKeys]}
                          selectedKeys={[selectedKeys]}
                          theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                          mode="inline"
                          id="custom-sidebar-menu">
                          <Menu.Item key="mis/dashboard">
                            <Link to="/mis/dashboard">
                              <span className="nav-item-icon"><DashboardIcon /></span>
                              <span className="nav-item-label"><IntlMessages id="sidebar.dashboard" /></span>
                            </Link>
                          </Menu.Item>
                          <li className="tool-tip">Workflow Tools</li>
                          <Menu.Item key="mis/submitted-for-verification" className="verify">
                            <Link to="/mis/submitted-for-verification">
                              <span className="nav-item-icon">
                                <VerifyIcon />
                                <span className="nav-item-badge">{this.props.dashboard && this.props.dashboard.visits && this.props.dashboard.visits.MySubmittedForVerification ? this.props.dashboard.visits.MySubmittedForVerification : 0}</span>
                              </span>
                              <span className="nav-item-label"><IntlMessages id="sidebar.submitted-for-verification" />{this.props.dashboard && this.props.dashboard.visits && this.props.dashboard.visits.MySubmittedForVerification ? this.props.dashboard.visits.MySubmittedForVerification : 0}</span>
                            </Link>
                          </Menu.Item>
                          {(<Menu.Item key="mis/worklist-visits">
                            <Link to="/mis/worklist-visits">
                              <span className="nav-item-icon"><i className="icon icon-listing-dbrd" /></span>
                              <span className="nav-item-label"><IntlMessages id="sidebar.worklist-visits" /></span>
                            </Link>
                          </Menu.Item>)}
                          <li className="tool-tip">Templates</li>
                          <Menu.Item key="mis/private-templates">
                            <Link to="/mis/private-templates">
                              <span className="nav-item-icon"><PrivateTempIcon /></span>
                              <span className="nav-item-label"><IntlMessages id="sidebar.private-macros" /></span>
                            </Link>
                          </Menu.Item>
                          {/* <Menu.Item key="mis/private-diagram">
                            <Link to="/mis/private-diagram"><PrivateDiagramIcon />
                              <IntlMessages id="sidebar.private-diagrams" /></Link>
                          </Menu.Item> */}
                          {showCaseLibrary && <Menu.Item key="mis/library">
                            <Link to="/mis/library">
                              <span className="nav-item-icon"><RadiologistIcon /></span>
                              <span className="nav-item-label"><IntlMessages id="sidebar.library" /></span>
                            </Link>
                          </Menu.Item>}
                        </Menu> :
                        authUser && authUser.role === "ROLE_TYP" ?
                          <Menu
                            defaultOpenKeys={[defaultOpenKeys]}
                            selectedKeys={[selectedKeys]}
                            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                            mode="inline"
                            id="custom-sidebar-menu">
                            <Menu.Item key="typ/dashboard">
                              <Link to="/typ/dashboard">
                                <span className="nav-item-icon"><DashboardIcon /></span>
                                <span className="nav-item-label"><IntlMessages id="sidebar.dashboard" /></span>
                              </Link>
                            </Menu.Item>
                            <Menu.Item key="typ/workload-list">
                              <Link to="/typ/workload-list">
                                <span className="nav-item-icon"><i className="icon icon-listing-dbrd" /></span>
                                <span className="nav-item-label"><IntlMessages id="sidebar.workload-list" /></span>
                              </Link>
                            </Menu.Item>
                            <Menu.Item key="typ/for-typing">
                              <Link to="/typ/for-typing">
                                <span className="nav-item-icon">
                                  <TypingIcon />
                                  <span className="nav-item-badge">{(dashboard && dashboard.visits && dashboard.visits.worklist) ? dashboard.visits.worklist : 0}</span>
                                </span>
                                <span className="nav-item-label"><IntlMessages id="sidebar.for-typing" /> - {(dashboard && dashboard.visits && dashboard.visits.worklist) ? dashboard.visits.worklist : 0}</span>
                              </Link>
                            </Menu.Item>
                            <Menu.Item key="typ/parked">
                              <Link to="/typ/parked">
                                <span className="nav-item-icon">
                                  <ParkedIcon />
                                  <span className="nav-item-badge">{(dashboard && dashboard.visits && dashboard.visits.parked) ? dashboard.visits.parked : 0}</span>
                                </span>
                                <span className="nav-item-label"><IntlMessages id="sidebar.parked" /> - {(dashboard && dashboard.visits && dashboard.visits.parked) ? dashboard.visits.parked : 0}</span>
                              </Link>
                            </Menu.Item>
                            <Menu.Item key="typ/submitted">
                              <Link to="/typ/submitted">
                                <span className="nav-item-icon">
                                  <SubmittedIcon />
                                  <span className="nav-item-badge">{(dashboard && dashboard.visits && dashboard.visits.submittedForVerification) ? dashboard.visits.submittedForVerification : 0}</span>
                                </span>
                                <span className="nav-item-label"><IntlMessages id="sidebar.submitted" /> - {(dashboard && dashboard.visits && dashboard.visits.submittedForVerification) ? dashboard.visits.submittedForVerification : 0}</span>
                              </Link>
                            </Menu.Item>
                            <li className="tool-tip">Templates</li>
                            <Menu.Item key="typ/private-templates">
                              <Link to="/typ/private-templates">
                                <span className="nav-item-icon"><PrivateTempIcon /></span>
                                <span className="nav-item-label"><IntlMessages id="sidebar.private-macros" /></span>
                              </Link>
                            </Menu.Item>
                            {/* <Menu.Item key="typ/group-templates">
                              <Link to="/typ/group-templates"><i className="icon icon-listing-dbrd" />
                                <IntlMessages id="sidebar.group-macros" /></Link>
                            </Menu.Item> */}
                          </Menu> :
                          <Menu
                            defaultOpenKeys={[defaultOpenKeys]}
                            selectedKeys={[selectedKeys]}
                            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                            mode="inline"
                            id="custom-sidebar-menu">
                            <MenuItemGroup key="main" className="gx-menu-group" title={<IntlMessages id="sidebar.unauthorized" />}>
                            </MenuItemGroup>
                          </Menu>
            }
            <div className="gx-customizer-item" style={{ marginLeft: "20px", marginBottom: "20px" }}>
              <Menu defaultOpenKeys={[defaultOpenKeys]} selectedKeys={[selectedKeys]} theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'} mode="inline" id="custom-sidebar-menu">
                <li className="tool-tip">System</li>
                <Menu.Item key="whats-new" className="whats-new-icon" onClick={this.handleWhatsNewModal}>
                  <span className="nav-item-icon"><Icon type="rocket" /></span>
                  <span className="nav-item-label">What's New</span>
                </Menu.Item>
                <Menu.Item key="contact-support" className="contact-icon" onClick={this.handleTicketModal}>
                  <span className="nav-item-icon"><ContactIcon /></span>
                  <span className="nav-item-label">Contact Support</span>
                </Menu.Item>
                <Menu.Item key="logout-button" className="logout-icon" onClick={() => this.handleLogout()}>
                  <span className="nav-item-icon"><AiOutlineLogout size={20} /></span>
                  <span className="nav-item-label">Logout</span>
                </Menu.Item>
              </Menu>
              {this.state.ticketModal &&
                <CreateTicketModal
                  visible={this.state.ticketModal}
                  handleCreateTicket={this.handleCancelModal}
                  onCancel={this.handleCancelModal}
                />}
              <WhatsNewModal
                visible={this.state.whatsNewModal}
                onCancel={this.handleCancelWhatsNewModal}
                mandatory={this.state.whatsNewMandatory}
                onComplete={this.handleWhatsNewComplete}
              />
            </div>
            <Claire />
          </CustomScrollbars>

          <div className="gx-customizer-item sidebar-modes-menu">
            <div className="theme-segment" role="radiogroup" aria-label="Colour theme">
              <button
                type="button"
                className={`theme-segment-option ${themeType !== THEME_TYPE_DARK ? 'active' : ''}`}
                onClick={() =>
                  this.onThemeTypeChange({
                    target: { value: THEME_TYPE_SEMI_DARK },
                  })
                }
              >
                <FiSun size={15} />
                <span>Light</span>
              </button>
              <button
                type="button"
                className={`theme-segment-option ${themeType === THEME_TYPE_DARK ? 'active' : ''}`}
                onClick={() =>
                  this.onThemeTypeChange({
                    target: { value: THEME_TYPE_DARK },
                  })
                }
              >
                <FiMoon size={15} />
                <span>Dark</span>
              </button>
            </div>
          </div>
          {
            authUser && (authUser.role == "ROLE_MIS" || authUser.role === "ROLE_MRT") ?
              (
                <Menu
                  defaultOpenKeys={[defaultOpenKeys]}
                  selectedKeys={[selectedKeys]}
                  theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                  mode="inline"
                  id="custom-sidebar-menu"
                  className="sidebar-connect-menu">
                  <Menu.Item key="mis/dashboard">
                    <Link to="#" className="connect-text">
                      <span className="nav-item-icon">
                        <i style={{ color: this.props.integrator.imageViewer === 'InteleViewer' ? 'green' : 'red', fontSize: 12 }} className="icon icon-circle" id="circle-icon" />
                      </span>
                      <span className="nav-item-label"><IntlMessages id="sidebar.connect" /></span>
                    </Link>
                  </Menu.Item>
                </Menu>
              ) : (
                null
              )
          }
        </div>
      </Auxiliary>
    );
  }
}

SidebarContent.propTypes = {};
export const mapDispatchToProps = dispatch => ({
  fetchDashboard: bindActionCreators(fetchDashboard, dispatch),
  setThemeType: bindActionCreators(setThemeType, dispatch),
  onNavStyleChange: bindActionCreators(onNavStyleChange, dispatch),
  userSignOut: bindActionCreators(userSignOut, dispatch),
  updateUserConfigurations: bindActionCreators(updateUserConfigurations, dispatch)
})

const mapStateToProps = ({ settings, auth, integrator, dashboard, activity }) => {
  const { navStyle, themeType, locale, pathname } = settings;
  const { authUser, configurations } = auth;
  const { unsavedChanges, selectedVisit } = activity;

  return { navStyle, themeType, locale, pathname, authUser, configurations, integrator, dashboard: dashboard.dashboard, unsavedChanges, selectedVisit}
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContent);

